// extracted by mini-css-extract-plugin
var _1 = "AIButton-moduleloading__Sc7sw";
export { _1 as "loading" }
